import React from 'react'
import PropTypes from 'prop-types'
import { Popup, Dialog } from 'antd-mobile'
import ImgPacket from '../../assets/red-packet/packet_3.png'
import ImgPacketOpen from '../../assets/red-packet/packet-o.png'
import {
  postMessage
  // , handleCovertPhone
} from '../../utils'

export class Packet2 extends React.PureComponent {

  static propTypes = {
    packetInfo: PropTypes.object
  }

  static defaultProps = {
    packetInfo: {}
  }

  state = {
    count: 1,
    turning: false,
    integral: null,
    modalVisible: false,
    record: []
  }

  // turning = false

  render () {
    let { packetInfo } = this.props
    let { integral, modalVisible, turning } = this.state
    return <div className={'RP__packet'}>
      {/*<img className={'RP__packet__button'}*/}
      {/*  style={{ transform: `translate(-50%, -50%) rotateY(${this.state.count * 360}deg)` }}*/}
      {/*  onClick={this.onClick} src={ImgPacketBtn} alt='' />*/}
      <div className={'RP__packet__info'}>
        {/*<div className={'RP__packet__text'}>本轮积分</div>*/}
        <div className={'RP__packet__text'}>{packetInfo['integralCount']}</div>
        {/*<div className={'RP__packet__sub'} onClick={this.onRuleClick}>红包规则</div>*/}
      </div>
      <img className={`RP__packet__img${turning ? ' RP__packet__img--turning' : ''}`}
           src={ImgPacket}
           alt=""
           onClick={this.onClick}/>
      <div
        className={'absolute z-10 bottom-4 text-center w-full text-amber-400'}
        onClick={this.onRuleClick}>
        红包规则
      </div>
      <Popup visible={modalVisible}
             bodyStyle={{ backgroundColor: 'unset', height: '100%' }}
             bodyClassName={'flex items-center justify-center'}
      >
        <div className={'RP__packet__wrapper'}>
          <img className={'RP__packet__open-img'} src={ImgPacketOpen} alt=""/>
          <div className={'RP__packet__details'}>恭喜！<br/>本次获得 {integral} 积分</div>
          <div className={'RP__packet__close'}
               onClick={() => this.setState({ modalVisible: false })}>关闭
          </div>
        </div>
      </Popup>
      {/*<Modal className={'RP__packet__modal'} visible={false}>*/}
      {/*  <div className={'RP__packet__wrapper'}>*/}
      {/*    <div className={'RP__packet__details'}>恭喜！<br/>本次获得 {integral} 积分</div>*/}
      {/*    <div className={'RP__packet__carousel'}>*/}
      {/*      /!* 这部分逻辑好像没用了，因为getPacketRecord根本没有调用*!/*/}
      {/*      /!*{record.length > 0 && <div>*!/*/}
      {/*      /!*  红包获取情况*!/*/}
      {/*      /!*  <Carousel vertical*!/*/}
      {/*      /!*    dots={false}*!/*/}
      {/*      /!*    dragging={false}*!/*/}
      {/*      /!*    swiping={false}*!/*/}
      {/*      /!*    autoplay*!/*/}
      {/*      /!*    infinite*!/*/}
      {/*      /!*    speed={500}*!/*/}
      {/*      /!*    // frameOverflow='visible'*!/*/}
      {/*      /!*    autoplayInterval={2000}*!/*/}
      {/*      /!*    resetAutoplay={false}*!/*/}
      {/*      /!*  >*!/*/}
      {/*      /!*    {record.map((item, index) => {*!/*/}
      {/*      /!*      return <div key={index}>{handleCovertPhone(item['phone'])} 获得 {item['value']} 积分</div>*!/*/}
      {/*      /!*    })}*!/*/}
      {/*      /!*  </Carousel>*!/*/}
      {/*      /!*</div>}*!/*/}
      {/*    </div>*/}
      {/*    <div onClick={() => this.setState({ modalVisible: false })} className={'RP__packet__close'}>关闭</div>*/}
      {/*  </div>*/}
      {/*</Modal>*/}
    </div>
  }

  onClick = () => {
    if (this.state.turning) return
    // this.props.onClick && this.props.onClick()
    if (!window.axios.getToken()) {
      window.toast.info('请先进行登陆', 1, () => {
        postMessage({ type: 'loginRequest' })
      })
    }
    let { packetInfo } = this.props
    this.setTurning()
    if (packetInfo['todayOver']) {
      Dialog.alert({
        title: '来晚啦！',
        content: '本日所有红包雨已结束，明天请早'
      }).then(() => {})
    } else if (packetInfo['started']) {
      // } else {
      this.postRequest(packetInfo['id'])
    } else {
      window.toast.info('少侠别急，红包还没开抢', 2)
    }
  }

  setTurning = () => {
    // 旧的红包逻辑，处理按钮图标旋转用的
    // this.turning = true
    // this.setState({ count: this.state.count + 1 })
    // setTimeout(() => this.turning = false, 1000)
    // 新的直接用turning标记，而且要放到state里
    this.setState({ turning: true })
    setTimeout(() => {this.setState({ turning: false })}, 1000)
  }

  onRuleClick = () => {
    Dialog.alert(
      {
        title: '红包规则',
        content: <div style={{ textAlign: 'left' }}>
          1.抢红包前须先登录账户 <br/>2.红包数量有限，先到先得送完即止
        </div>
      }
    ).then(() => {})
  }

  postRequest = (redPackageId) => {
    window.toast.show('')
    let config = {
      method: 'post',
      url: window.API.RedPacket.requestPacket(redPackageId)
    }
    window.axios.request(config)
      .then(res => {
        window.toast.hide()
        // this.getPacketRecord(redPackageId)
        this.setState({ modalVisible: true, integral: res })
      })
      .catch(error => {
        console.error(error)
        window.toast.info(error.message)
      })
    // .finally(() => {
    //   this.setState({ modalVisible: true, integral: 0 })
    // })
  }

  getPacketRecord = (redPackageId) => {
    let config = {
      method: 'put',
      url: window.API.RedPacket.getPacketRecord(redPackageId),
      data: {
        currentDate: window.moment().format('YYYY-MM-DD'),
        mark: 1
      }
    }
    window.axios.request(config)
      .then(res => {
        if (res && res['length'] > 0) {
          let record = []
          for (let i = 0; i < 3; i++) {
            record.push(res[0])
          }
          this.setState({ record })
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

}
